var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcStep(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5835 6C14.2135 6 13.0835 7.52 13.0835 9.4C13.0835 10.88 13.7835 12.11 14.7535 12.58L14.8335 12.62V19H16.3335V12.62L16.4135 12.59C17.3835 12.12 18.0835 10.89 18.0835 9.41C18.0835 7.53 16.9635 6 15.5835 6ZM11.3335 6C11.0635 6 10.8335 6.22 10.8335 6.5V9H10.0835V6.5C10.0835 6.22 9.8635 6 9.5835 6C9.3035 6 9.0835 6.22 9.0835 6.5V9H8.3335V6.5C8.3335 6.22 8.1135 6 7.8335 6C7.5535 6 7.3335 6.22 7.3335 6.5V10.3C7.3335 11.23 7.9735 12.01 8.8335 12.23V19H10.3335V12.23C11.1935 12.01 11.8335 11.23 11.8335 10.3V6.5C11.8335 6.22 11.6135 6 11.3335 6ZM20.8335 4H4.8335V20H20.8335V4ZM20.8335 2C21.9335 2 22.8335 2.9 22.8335 4V20C22.8335 21.1 21.9335 22 20.8335 22H4.8335C3.7335 22 2.8335 21.1 2.8335 20V4C2.8335 2.9 3.7335 2 4.8335 2H20.8335Z",
    fill: "#3D454D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStep);
export default __webpack_public_path__ + "static/media/ic_step.ad989d9b41671887d51b22c2079ed59c.svg";
export { ForwardRef as ReactComponent };